export class EntidadeTipo {

  constructor(id: number) {
    this.id = id;
  }

  id: number;
  nome: string;
}
